<template>
  <div>
      <BaseInputWithContextMenu
        :ref="'contextMenuBaseForRichEdit_' + inputElementId"
        :target-id="inputElementId"
        :is-read-only="isReadOnlyState"
        :value="Value"
        :control="$attrs.control"
        :additional-menu-items="additionalMenuItems"
        :enable-speech-features="true"
        :enable-system-options="true"
        @input="onEditorInput"
        @control-changed="setChangedStatus"
        @context-menu-select="handleContextMenuSelect"
        :is-ckeditor="true"
      >
        <ckeditor
          ref="ckeditorInstance" 
          v-b-tooltip.hover :title="Hint"
          v-model="Value" 
          :config="editorConfig"
          :disabled="this.$attrs.control.isReadOnly || NoteIsVoid || this.isReadOnly"
          :read-only="this.$attrs.control.isReadOnly || NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly"
          @input="onEditorInput"
          @blur="onEditorBlur"
          :editor-url="editorUrl"
          v-bind:style="style"
          :class="componentClass"
          @ready="onEditorReady"
          :id="inputElementId">
        </ckeditor>
    </BaseInputWithContextMenu>

    <MdPatientDiagCodes v-if="activateModalDiagCodes"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:RecordId="this.$attrs.AdmissionRecId"
      v-bind:TitleWindow="outComeTitle"
      v-bind:DateFrom="this.DateFrom"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientDiagCodes>
    <MdPatientInsurances v-if="activateModalInsurance"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientInsurances>
    <MdPatientContacts v-if="activateModalContacts"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientContacts>
    <MdPatientAllergiesOutCome v-if="activateModalAllergies"
      v-bind:ModalId="controlID"
      v-bind:AdmissionRecordId="this.$route.params.recordid"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientAllergiesOutCome>
    <MdGenericOutCome v-if="activateModalGeneric"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      v-bind:outComeDescription="outComeDescription"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdGenericOutCome>
    <MdPainAssessmentNotesOutCome v-if="activeModalPainAssessment"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPainAssessmentNotesOutCome>
    <MdPatientVitalSingOutCome v-if="activeModalVitalSign"
      v-bind:ModalId="controlID"
      v-bind:TitleWindow="outComeTitle"
      v-bind:outComeCode="outComeCode"
      v-bind:ComponentKind="'RichEdit'"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientVitalSingOutCome>
    <MdGetLastAnswers v-if="showGetLastAnswers"
      @getCancel="onCancelGetLastAnswers($event)"
      @getOK="onOKGetLastAnswers($event)"
      v-bind:ControlId="controlID"
      v-bind:PatientCode="PatientCode"
      v-bind:TransDate="TransDate"
    />
    <MdPatientMedicationsOutCome v-if="activateModalMedications"
      v-bind:ModalId="controlID"
      v-bind:PatientCode="this.PatientCode"
      v-bind:TitleWindow="outComeTitle"
      @getCodeConditionOK="onCodeConditionOk($event)"
      @getCancel="onCancel($event)"
    ></MdPatientMedicationsOutCome>
    <!-- <MdTextSpeech></MdTextSpeech> -->

    <button
      v-if="!isReadOnlyState && $store.state.useAIAssist"
      :style="aiButtonStyle"
      type="button"
      :title="$t('AiWriter.HelpMeWrite')"
      @click="openAiWriter"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#19BEE8" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5Z"/>
        <path d="M19 15l.75 2.25L22 18l-2.25.75L19 21l-.75-2.25L16 18l2.25-.75Z"/>
        <path d="M5 3l.5 1.5L7 5l-1.5.5L5 7l-.5-1.5L3 5l1.5-.5Z"/>
      </svg>
    </button>

    <b-modal
      v-model="showAiPanel"
      :id="'ai-writer-modal-recn-' + controlID"
      :title="$t('AiWriter.Title')"
      hide-footer
      size="md"
      @shown="makeAiModalDraggable"
      @hidden="resetAiPanel"
    >
      <div class="ai-writer-body">
        <label class="ai-label">{{ $t('AiWriter.WhatToWrite') }}</label>
        <b-form-textarea
          ref="aiInstructionInput"
          v-model="aiInstruction"
          :placeholder="$t('AiWriter.Placeholder')"
          rows="3"
          class="ai-instruction-input"
          :disabled="isGenerating"
        ></b-form-textarea>

        <div class="mt-2 d-flex justify-content-end">
          <b-button
            variant="primary"
            size="sm"
            :disabled="isGenerating || !aiInstruction.trim()"
            @click="generateText"
          >
            <span v-if="isGenerating">{{ $t('AiWriter.Generating') }}</span>
            <span v-else>{{ $t('AiWriter.Generate') }}</span>
          </b-button>
        </div>

        <div v-if="aiError" class="mt-2 text-danger small">{{ aiError }}</div>

        <div v-if="aiGeneratedText" class="ai-preview mt-3">
          <label class="ai-label">{{ $t('AiWriter.GeneratedText') }}</label>
          <b-form-textarea
            v-model="aiGeneratedText"
            class="ai-preview-text"
            rows="5"
            max-rows="10"
          ></b-form-textarea>
          <div class="mt-2 d-flex justify-content-end">
            <b-button variant="primary"           size="sm" class="mr-1" @click="aiInsertText">{{ $t('AiWriter.Insert') }}</b-button>
            <b-button variant="outline-primary"   size="sm" class="mr-1" @click="aiReplaceText">{{ $t('AiWriter.Replace') }}</b-button>
            <b-button variant="outline-primary"   size="sm" class="mr-1" :disabled="isGenerating" @click="generateText">{{ $t('AiWriter.Regenerate') }}</b-button>
            <b-button variant="outline-secondary" size="sm" @click="closeAiWriter">{{ $t('AiWriter.Discard') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Utils from '@/common/utils.js'
  import { EventBus } from '../../event-bus.js';
  import GlobalService from '@/services/global.service'
  import ApiService from '@/services/api.service';
  import Vue from 'vue';
  import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";

  Vue.use(ContextMenuPlugin);
  export default {
     name: 'MdRichEditCN',
    mixins: [EventBus],
    props: {     
     MaxRows: String,
     Rows: String,
     MaxLength: String,
     isReadOnly:Boolean,
     value:[String],
     Name:String,
     Placeholder:String,
     TransDate: String,
     NoteId: String,
     DateFrom:String,
     id: [String, Number],
     HideToolBar: Boolean,
     PatientCode: String,
     IsCommonPart: Boolean,
     IsGroupContainer: Boolean,
     aiAssistContext: String,
     FormId: String,
   },
    data() {
      return {
         Value: this.value,
          NoteIsVoid:false,        
         style: {
          border: 'solid 1px #e0e0e0 !important',
          position:'absolute',
          top: this.$attrs.control.controlTop+'px',          
          left:this.$attrs.control.controlLeft+'px',
          borderColor: '#e0e0e0 !important',
          textAlign:'',         
          borderRadius: '5px',
        },
         Hint: this.$attrs.control.controlHint,
         controlID:String(this.$attrs.control.controlID),
         outComeDescription: Utils.strToTitleCase(this.$attrs.control.outComeDescription),
         outComeTemplateCode:this.$attrs.control.outComeTemplateCode,
         outComeTitle: Utils.strToTitleCase(this.$attrs.control.outComeDescription),
         outComeCode:this.$attrs.control.outComeCode,
         Invalid:false,
         isRequired: this.$attrs.control.isRequired,
         activateModalInsurance:false,
         activateModalContacts:false,
         activateModalDiagCodes:false,
         activateModalAllergies:false,
         activateModalGeneric:false,
         activeModalPainAssessment:false,
         activeModalVitalSign:false,
         showGetLastAnswers: false,
         activateModalMedications: false,
         //PatientCode: this.$route.params.id,
         editor: null,
         menuItems:[],
         targetId: "target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
         // AI Writer
         showAiPanel: false,
         aiInstruction: '',
         aiGeneratedText: '',
         aiError: '',
         isGenerating: false,
         menuTargetId:"#target-"+this.$attrs.HeaderId+"-"+this.$attrs.control.controlID,
         //componentClass: this.$attrs.control.outComeCode ? 'outcome' : 'cursor-context-menu',
          componentClass: this.$attrs.control.outComeCode ? 'cutescroll cursor-context-menu outcome' : 'cutescroll cursor-context-menu',
         editorUrl: '/ckeditor/ckeditor.js',
         isLoadingCkeditor: true,
         editorConfig: {
          controlId: this.$attrs.control.controlID,
          noteId: this.NoteId,
          hideTB: this.HideToolBar || this.$attrs.control.isReadOnly || this.$attrs.control.controlHeight < 100,
          bodyId: 'ckeditorBody'+this.$attrs.control.controlID,
          ckHeight: "",
          on: {
                instanceReady : (evt) =>
                {
                  document.getElementById( `${evt.editor.id}_top` ).style.display = 'none';

                  if (evt.editor.config.readOnly) {
                    document.getElementById( `${evt.editor.id}_contents` ).style.backgroundColor = 'rgb(233, 236, 239)';
                  }

                  evt.editor.editable().on('input', () => {
                   const data = evt.editor.getData();
               
                   var changed = {
                      ControlId: evt.editor.config.controlId,
                      Changed: true,
                      NoteId: evt.editor.config.noteId
                   };

                   this.$emit('input', data);
                   EventBus.$emit('onControlWasChanged', changed);
                  });
                    
                },

                beforeCommandExec: async function(evt) {
                  if (evt.data.name == 'toolbarCollapse') {
                    evt.editor.config.ckHeight = evt.editor.container.$.offsetHeight
                  }
                },

                afterCommandExec: async function(evt) {
                  if (evt.data.name == 'toolbarCollapse') {
                    evt.editor.resize(evt.editor.container.$.offsetWidth, evt.editor.config.ckHeight);
                  }
                },

                focus: async function(evt) {
                  if (!evt.editor.config.hideTB) {
                    document.getElementById( `${evt.editor.id}_top` ).style.display = null;
                    evt.editor.resize(evt.editor.container.$.offsetWidth, evt.editor.config.height);
                  }
                },

                blur: async (evt) => {
                  document.getElementById( `${evt.editor.id}_top` ).style.display = 'none';
                  evt.editor.resize(evt.editor.container.$.offsetWidth, evt.editor.config.height);
                  // Emit current editor data on blur to capture text inserted externally
                  // (e.g. third-party dictation tools that write directly to the DOM
                  // without firing the input event)
                  const data = evt.editor.getData();
                  if (data !== this.Value) {
                    this.Value = data;
                    this.$emit('input', data);
                    var changed = {
                      ControlId: evt.editor.config.controlId,
                      Changed: true,
                      NoteId: evt.editor.config.noteId
                    };
                    EventBus.$emit('onControlWasChanged', changed);
                  }
                },

                paste: async function(evt) {
                  let rtfData = evt.data.dataTransfer.getData( 'text/rtf', true);
                  const filesCount = evt.data.dataTransfer.getFilesCount()
                  const textData = evt.data.dataTransfer.getData( 'Text', true);
                  const htmlData = evt.data.dataTransfer.getData( 'text/html', true);
                  let rtfContent= { rtf:[] }
                  if(!textData && !htmlData && filesCount > 0){
                    let imagen = evt.data.dataTransfer.getFile(0);
                    let reader = new FileReader();
                    reader.onload = function(e) {
                      let element = evt.editor.document.createElement('img', {
                        attributes: {
                          src: e.target.result
                        }
                      });
                      evt.editor.insertElement(element);             
                    };
                    reader.readAsDataURL(imagen);
                  }

                  if(filesCount == 0 && rtfData && !htmlData){
                    evt.cancel();
                    rtfData = rtfData.replaceAll(/\\\*\\fldinst HYPERLINK .*"/g,'');
                    rtfData = rtfData.replaceAll('>', '');
                    rtfData = rtfData.replaceAll('<', '');
                    rtfContent.rtf[0] = rtfData
                    await GlobalService.RtfToHtml(rtfContent)
                      .then(( response) => {
                        if(response.status == '200'){
                            this.htmlContent = response.data.html[0];
                            evt.editor.insertHtml(this.htmlContent);
                        }
                      })
                      .catch((error) => {
                        if(error.response) {
                          evt.cancel();
                        }
                      });
                  }
                  var changed = {
                    "ControlId":this.config.controlId,
                    "Changed":true,
                    "NoteId":this.config.noteId
                  }
                  EventBus.$emit('onControlWasChanged', changed);
                }
              },
          title: false, 
          toolbar: [ 
            {
              name: 'basicstyles',
              items: ['Bold','Italic','Underline','Strike','-','NumberedList','BulletedList','-','Outdent','Indent','-',
                      'JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock','-','Link','Unlink','-','Table','Image']
            },
            {
              name: 'format',
              items: ['Styles','Format','Font','FontSize','TextColor','BGColor']
            },
          ],
          width: this.$attrs.control.controlWidth,
          height: this.$attrs.control.controlHeight,
          extraPlugins: 'tableresize,divarea',
          removePlugins: 'save,smiley,forms,flash,templates,print,preview,iframe,find,exportpdf,\
                          specialchar,pagebreak,wsc,scayt,liststyle,div,a11yhelp,\
                          about,language,indentblock,bidi,removeformat,sourcearea,\
                          maximize,htmlwriter,horizontalrule,showblocks,\
                          blockquote,copyformatting,selectall,newpage,elementspath,resize',
          removeButtons: 'Subscript,Superscript,Cut,Copy,PasteText,PasteFromWord',
          readOnly: this.$attrs.control.isReadOnly || this.NoteIsVoid || this.isReadOnly,
          enterMode: 2,
          shiftEnterMode: 2
         }
      }
    },

    watch: {
        value: {
          immediate: true,
          handler: function(newModel) {
            this.Value = newModel;
          }
        }
    },
    computed: {
      inputElementId() {
        return this.$attrs.HeaderId + '-' + this.$attrs.control.controlID;
      },
      
      isReadOnlyState() {
        return this.$attrs.control.isReadOnly || this.NoteIsVoid || this.$attrs.control.IsChartReview || this.isReadOnly;
      },
      
      aiButtonStyle() {
        const ctrl = this.$attrs.control;
        return {
          position: 'absolute',
          top: (parseInt(ctrl.controlTop) + 4) + 'px',
          left: (parseInt(ctrl.controlLeft) + parseInt(ctrl.controlWidth) - 32) + 'px',
          zIndex: 2,
          background: 'none',
          border: 'none',
          padding: '0',
          cursor: 'pointer',
          lineHeight: '1',
          opacity: '1'
        };
      },

      additionalMenuItems() {
        const items = [];
        if (!this.IsCommonPart) {
          items.push({ text: this.$t('ContextMenu.GetLast10'), id: "gettenlastans" });
        }
        if(this.outComeDescription) {
          items.push({text: this.outComeDescription, id: "outcome"})
        }
        return items;
      },
      enableSpeechFeatures() {
        // Example: Do not enable speech in numeric fields
        const controlDataType = this.$attrs.control.controlDataType;
        return controlDataType !== 'Integer' && controlDataType !== 'Money';
      },
      enableSystemOptions() {
          // Example: Do not enable speech in numeric fields
          const controlDataType = this.$attrs.control.controlDataType;
          return controlDataType !== 'Integer' && controlDataType !== 'Money';
      }
  },
  methods:{

     deActivateModal(){
       if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPATIENTCONTACTS')
       this.activateModalContacts = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTINSURANCES')
       this.activateModalInsurance = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTDIAGCODES')
       this.activateModalDiagCodes = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMALLERGIESEHR')
       this.activateModalAllergies = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES')
       this.activateModalGeneric = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES')
       this.activeModalPainAssessment = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES')
       this.activeModalVitalSign = false
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMCUSTOMPATIENTMEDICATIONS')
        this.activateModalMedications = false
     },

     onCancel(){
       this.deActivateModal()
     },

     onEditorInput(value){
      this.$emit('input',value);
      if (!this.isLoadingCkeditor) {
        this.Invalid = value.length == 0 && this.$attrs.control.isRequired ? true : false;
        this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
        this.setChangedStatus()
      }
     },

     onCodeConditionOk(result) {
       if(result) {
          this.Value = result;
          this.$emit('input',result);
          this.setChangedStatus()
       }
       this.deActivateModal()
     },

       InitializeVariables(){
      // this.style.backgroundColor = this.$attrs.control.isReadOnly ? '#e9ecef !important' :'';
        if(this.$attrs.control.isReadOnly || this.isReadOnly){
         // this.style.backgroundColor = '#dfe4eb !important';
         this.style.backgroundColor = '#e9ecef !important';
        }else{
           this.style.backgroundImage = 'linear-gradient(130deg, white, rgb(241, 253, 255))';
        }
       },

     onEditorBlur(){
       this.$emit('blur',this.Value)
       this.Invalid = this.Value.length == 0 && this.isRequired ? true : false;
       this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
     },

     ChangeValue(value) {
        this.onEditorInput(value);
     },

    showModal() {
      if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPATIENTCONTACTS')
       this.activateModalContacts = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTINSURANCES')
       this.activateModalInsurance = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMPATIENTDIAGCODES')
       this.activateModalDiagCodes = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMALLERGIESEHR')
       this.activateModalAllergies = true 
      else if(this.outComeTemplateCode.toUpperCase() === 'TFMMDNOTEOUTCOMESTUDIES')
       this.activateModalGeneric = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDPAINASSESSMENTNOTES')
       this.activeModalPainAssessment = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMMDVITALSIGNSNOTES')
       this.activeModalVitalSign = true
      else if(this.outComeTemplateCode.toUpperCase() === 'TFRMCUSTOMPATIENTMEDICATIONS')
        this.activateModalMedications = true  
    },

    showModalGetLastAnswers() {
      this.showGetLastAnswers = true
    },

    onCancelGetLastAnswers(){
      this.showGetLastAnswers = false
    },

    onOKGetLastAnswers(value) {
      this.Value = value
      this.showGetLastAnswers = false
      this.$emit('input',value);
      this.setChangedStatus()
    },

    handlerClick(evt){
      if(!this.$attrs.control.isReadOnly && !this.isReadOnly) {
        this.$refs.menu.open(evt)
      }
    },

    setValid(state){
        this.style.borderColor = state ? '#dc3545 !important': '#e0e0e0 !important'
    },

    setRequired(value) {
      this.isRequired = value;
      if (!value) {
        this.style.borderColor = '#e0e0e0 !important';
      } else if (this.Value === null || this.Value === undefined || this.Value.length == 0) {
        this.Invalid = true;
        this.style.borderColor = '#dc3545 !important';
      }
    },

    setChangedStatus(){
      var changed = {
        "ControlId":this.$attrs.control.controlID,
        "Changed":true,
        "NoteId":this.NoteId
      }
      EventBus.$emit('onControlWasChanged', changed);
    },

    onEditorReady(editor){
      this.editor = editor;
      if (editor.contextMenu) {
        editor.removeMenuItem('cut');
        editor.removeMenuItem('copy');
        editor.removeMenuItem('paste');
      }
      this.isLoadingCkeditor = false;

      const editable = editor.editable();
      if (editable && editable.$) {
        editable.$.addEventListener('blur', () => {
          const data = editor.getData();
          if (data !== this.Value) {
            this.Value = data;
            this.$emit('input', data);
            EventBus.$emit('onControlWasChanged', {
              ControlId: this.$attrs.control.controlID,
              Changed: true,
              NoteId: this.NoteId
            });
          }
        });
      }
    },

    makeAiModalDraggable() {
      this.$nextTick(() => {
        const modalId = 'ai-writer-modal-recn-' + this.controlID;
        const outer = document.getElementById(`${modalId}___BV_modal_outer_`);
        const dialog = outer?.querySelector('.modal-dialog');
        const header = outer?.querySelector('.modal-header');
        if (!dialog || !header) return;
        header.style.cursor = 'move';
        let dragging = false, offsetX = 0, offsetY = 0;
        header.onmousedown = (e) => {
          e.preventDefault();
          const rect = dialog.getBoundingClientRect();
          offsetX = e.clientX - rect.left;
          offsetY = e.clientY - rect.top;
          dragging = true;
          dialog.style.position = 'fixed';
          dialog.style.margin = '0';
          dialog.style.transform = 'none';
          dialog.style.width = `${rect.width}px`;
          dialog.style.left = `${rect.left}px`;
          dialog.style.top = `${rect.top}px`;
        };
        document.onmousemove = (e) => {
          if (!dragging) return;
          dialog.style.left = `${e.clientX - offsetX}px`;
          dialog.style.top = `${e.clientY - offsetY}px`;
        };
        document.onmouseup = () => { dragging = false; };
        this.$refs.aiInstructionInput.focus();
      });
    },

    openAiWriter() {
      this.showAiPanel = true;
    },

    closeAiWriter() {
      this.showAiPanel = false;
    },

    resetAiPanel() {
      this.aiInstruction = '';
      this.aiGeneratedText = '';
      this.aiError = '';
      this.isGenerating = false;
    },

    async generateText() {
      if (!this.aiInstruction.trim()) return;
      this.isGenerating = true;
      this.aiError = '';
      this.aiGeneratedText = '';
      try {
        const plainText = this.editor ? this.editor.editable().getText() : (this.Value || '');
        const payload = {
          instruction: this.aiInstruction,
          formId: this.FormId,
          controlId: this.controlID,
          patientCode: this.PatientCode,
          transDate: this.TransDate,
        };
        if (plainText.trim()) payload.existingText = plainText;
        if (this.aiAssistContext) payload.context = this.aiAssistContext;
        const response = await ApiService.post('AiAssist', payload);
        this.aiGeneratedText = response.data.generatedText || '';
      } catch {
        this.aiError = this.$t('AiWriter.Error');
      } finally {
        this.isGenerating = false;
      }
    },

    aiInsertText() {
      if (this.editor) {
        this.editor.editable().appendText('\n' + this.aiGeneratedText);
        this.editor.focus();
        this.$emit('input', this.editor.getData());
        this.setChangedStatus();
      }
      this.closeAiWriter();
    },

    aiReplaceText() {
      if (this.editor) {
        this.editor.setData(this.aiGeneratedText);
        this.$emit('input', this.editor.getData());
        this.setChangedStatus();
      }
      this.closeAiWriter();
    },

    handleContextMenuSelect: function(args ) {
      if(args === 'gettenlastans') {
        this.showModalGetLastAnswers()
      }
      if(args === 'outcome') {
        this.showModal()
      }  
    },

    setValueS2T( sp ){
      if (this.editor) {
        this.editor.insertText(sp);
        const data = this.editor.getData();
        this.Value = data;
        this.$emit('input', data);
        this.setChangedStatus();
      } else {
        let sp2t = this.value ? this.value + sp : sp;
        this.Value = sp2t;
        this.$emit('input', sp2t);
        this.setChangedStatus();
      }
    },

    onInput(value) {
      this.Value = value;
      this.$emit('input',value)
      this.setChangedStatus()
    },
  },

  created(){    
    EventBus.$on("onSetReadOnly", function (e,id) {
      if(this.$attrs.HeaderId === id){
        this.NoteIsVoid = e;
      }
      }.bind(this));
  if(this.$attrs.NoteIsVoid){
    this.NoteIsVoid = this.$attrs.NoteIsVoid;
  }
  EventBus.$on("receivedS2T", function (event) {
      if( event.ControlId == this.$attrs.control.controlID){
        this.setValueS2T( event.finalSentence )
      }
    }.bind(this))
},

  mounted(){
    this.InitializeVariables();
    if (!this.IsCommonPart && this.IsGroupContainer && this.$attrs.control.isCommonControlNote) {
      this.Hint = this.$t('GroupNotesDashboard.ToCompletedInGroupFocus')
    }

    this.$nextTick(() => {
      const ckeditorRef = this.$refs.ckeditorInstance
      const contextRef = this.$refs[`contextMenuBaseForRichEdit_${this.inputElementId}`]
      if (ckeditorRef && contextRef) {
        contextRef.setCKEditorRef(ckeditorRef)
      } else {
        console.warn(`[MdEdit] ⚠️ No se pudo vincular CKEditorRef para ${this.inputElementId}`)
      }
    })
  }
}
</script>

<style>
.scroll{
	overflow: hidden !important;
}

.cke_inner, .cke_wysiwyg_frame, .cke_wysiwyg_div{
  background: transparent !important;
}
.cke_chrome {
  border: 0 !important;
}

.ai-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
  display: block;
}

.ai-instruction-input {
  font-size: 13px;
}

.ai-preview {
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.ai-preview-text {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 13px;
  white-space: pre-wrap;
  max-height: 200px;
  overflow-y: auto;
}
</style>